/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../common";
import type {
  ERC1155,
  ERC1155Interface,
} from "../../../../../../contracts/submodules/fwen1155/contracts/erc/ERC1155";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC1155ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC1155ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC1155__factory extends ContractFactory {
  constructor(...args: ERC1155ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ERC1155> {
    return super.deploy(overrides || {}) as Promise<ERC1155>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ERC1155 {
    return super.attach(address) as ERC1155;
  }
  override connect(signer: Signer): ERC1155__factory {
    return super.connect(signer) as ERC1155__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC1155Interface {
    return new utils.Interface(_abi) as ERC1155Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155 {
    return new Contract(address, _abi, signerOrProvider) as ERC1155;
  }
}
